<template>
    <div class="content-header" v-if="$crumbs && $crumbs.crumbs && $crumbs.crumbs.length > 1">
        <div class="breadcrumb-wrapper">
            <ul class="breadcrumb">
                <template>
                    <ul class="d-flex align-items-center">
                        <li class="breadcrumb-item">
                            <router-link :to="{name: 'home'}">
                                <inline-svg src="/assets/img/icons/home-line.svg"></inline-svg>
                            </router-link>
                        </li>
                        <li class="breadcrumb-item" v-for="(crumb, index) in $crumbs.crumbs">
                            <router-link v-if="crumb.name && index < $crumbs.crumbs.length -1" :to="{name:  crumb.name}">
                                {{ crumb.label }}
                            </router-link>
                            <template v-else>
                                <span>{{ crumb.label }}</span>
                            </template>
                        </li>
                    </ul>
                </template>
            </ul>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name: 'PageHeader',
    props: ['title'],
    computed: {
        ...mapState({
            meta: state => state.meta,
        })
    },
}
</script>
